// extracted by css-extract-rspack-plugin
export default {"select":"select-UnyZJI","action":"action-zHlj5V"};